import { render } from "./ProductSkeleton.vue?vue&type=template&id=3993897b&scoped=true"
import script from "./ProductSkeleton.vue?vue&type=script&lang=js"
export * from "./ProductSkeleton.vue?vue&type=script&lang=js"

import "./ProductSkeleton.vue?vue&type=style&index=0&id=3993897b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3993897b"]])

export default __exports__